"use client";

import { useState } from "react";
import Blink from "react-blink-text";
import {
  Dialog,
  DialogPanel,
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
  Popover,
  PopoverButton,
  PopoverGroup,
  PopoverPanel,
} from "@headlessui/react";
import {
  ArrowPathIcon,
  Bars3Icon,
  ChartPieIcon,
  CursorArrowRaysIcon,
  FingerPrintIcon,
  SquaresPlusIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";
import {
  ChevronDownIcon,
  PhoneIcon,
  PlayCircleIcon,
} from "@heroicons/react/20/solid";
import { Link } from "react-router-dom";

const products = [
  {
    name: "MEASI",
    href: "#",
    path: "/measi",
  },
  {
    name: "The New College",
    href: "#",
    path: "/the new college",
  },
  {
    name: "Administration",
    href: "#",
    path: "/adminstration",
  },
  {
    name: "Autonomy",
    href: "#",
    path: "/autonomy",
  },
  {
    name: "NAAC",
    href: "#",
    path: "/naac",
  },
  // {
  //   name: "NIRF",
  //   href: "#",
  //   path: "/nirfa",
  // },
  {
    name: "AISHE",
    href: "#",
    path: "/aishe",
  },
  {
    name: "Code of Conduct",
    href: "#",
    path: "/codeofconduct",
  },
];

const links = [
  {
    name: "Student / Faculty Login",
    href: "#",
    path: "/SFlogin",
  },
  {
    name: "Online Payment",
    href: "#",
    path: "/onlinepayment",
  },
  {
    name: "Library",
    href: "#",
    path: "/Library",
  },
  {
    name: "Education Verification",
    href: "#",
    path: "/everification",
  },
  {
    name: "Grievance",
    href: "#",
    path: "/Grievance",
  },
  {
    name: "Download",
    href: "#",
    path: "/download",
  },
  {
    name: "Scholarships and Fellowships",
    href: "#",
    path: "/Scholarships and Fellowships",
  },
  {
    name: "Attendance Report",
    href: "#",
    path: "/Attendance Report",
  },
];

const feedback = [
  {
    name: "Employee",
    href: "#",
    path: "/Employee",
  },
  {
    name: "Parents",
    href: "#",
    path: "/Parents",
  },
  {
    name: "Students",
    href: "#",
    path: "/Students",
  },
  {
    name: "Alumni",
    href: "#",
    path: "/Alumni",
  },
];

const services = [
  {
    name: "Placement Cell",
    href: "#",
    path: "/Placement Cell",
  },
  {
    name: "Scholarship",
    href: "#",
    path: "/Scholarship",
  },
  {
    name: "Capacity Development",
    href: "#",
    path: "/Capacity Development",
  },
  {
    name: "Students Union",
    href: "#",
    path: "/Students Union",
  },
  {
    name: "Grievance / Request",
    href: "#",
    path: "/Grievance / Request",
  },
  {
    name: "Staff Association",
    href: "#",
    path: "/Staff Association",
  },
  {
    name: "IIEC",
    href: "#",
    path: "/IIEC",
  },
];

const acadamic = [
  {
    name: "Departments",
    href: "#",
    path: "/Departments",
  },
  {
    name: "Faculty",
    href: "#",
    path: "/Faculty",
  },
  {
    name: "Administrative Staff",
    href: "#",
    path: "/Administrative Staff",
  },
  {
    name: "Programmes",
    href: "#",
    path: "/Programmes",
  },
  {
    name: "Syllabus",
    href: "#",
    path: "/Syllabus",
  },
  {
    name: "Programme Outcomes",
    href: "#",
    path: "/Programme Outcomes",
  },
  {
    name: "Physical Education",
    href: "#",
    path: "/Physical Education",
  },
  {
    name: "Academic Calender",
    href: "#",
    path: "/Academic Calender",
  },
];

const admission = [
  {
    name: "General Instruction",
    href: "#",
    path: "/generalinstruction",
  },
  {
    name: "Fee Structure",
    href: "#",
    path: "/Fee Structure",
  },
  {
    name: "Rules & Regulations",
    href: "#",
    path: "/Rules & Regulations",
  },
  {
    name: "Admission Policy",
    href: "#",
    path: "/Admission Policy",
  },
  {
    name: "Admission Committee",
    href: "#",
    path: "/Admission Committee",
  },
  {
    name: "Online Applications",
    href: "#",
    path: "/Online Applications",
  },
];

// const callsToAction = [
//   { name: "Watch demo", href: "#", icon: PlayCircleIcon },
//   { name: "Contact sales", href: "#", icon: PhoneIcon },
// ];

export default function Example() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        zIndex: "999",
      }}
      className="bg-white"
    >
      <nav
        aria-label="Global"
        className="mx-auto flex max-w-7xl items-center justify-between p-2 lg:px-8"
      >
        <div className="flex lg:flex-1">
          <Link className="lg:-ml-32 " to="/">
            <img
              alt=""
              src="https://thenewcollege.edu.in/images/New%20logo%20banner.png"
              className="h-28 w-auto"
            />
          </Link>
        </div>
        <div className="flex lg:hidden">
          <button
            type="button"
            onClick={() => setMobileMenuOpen(true)}
            className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
          >
            <Bars3Icon aria-hidden="true" className="size-6" />
          </button>
        </div>
        <div className="flex flex-col lg:-mr-20 lg:ml-5">
          <div>
            <PopoverGroup className="hidden lg:flex lg:gap-x-4">
              <Link
                style={{ fontSize: "16px" }}
                className=" font-semibold text-gray-900"
                to="/"
              >
                {" "}
                <li>Home |</li>{" "}
              </Link>
              <Link
                to="/activies"
                style={{ fontSize: "16px" }}
                className=" font-semibold text-gray-900"
              >
                {" "}
                <li>Activies |</li>{" "}
              </Link>
              <Link
                to="/facilities"
                style={{ fontSize: "16px" }}
                className=" font-semibold text-gray-900"
              >
                {" "}
                <li>Facilities |</li>{" "}
              </Link>

              <Link
                to="/alumini"
                style={{
                  fontSize: "16px",
                  transition: "ease-in-out",
                }}
                className=" font-semibold text-gray-900"
              >
                Alumini |
              </Link>
              <Link
                to="/grievances"
                style={{ fontSize: "16px" }}
                className=" font-semibold text-gray-900"
              >
                {" "}
                <li>Grievances |</li>{" "}
              </Link>
              <Link
                to="/moe"
                style={{ fontSize: "16px" }}
                className=" font-semibold text-gray-900"
              >
                {" "}
                <li>MoE |</li>{" "}
              </Link>

              <Link
                to="/payment"
                style={{ fontSize: "16px" }}
                className=" font-semibold text-gray-900"
              >
                {" "}
                <li>Online Payment |</li>{" "}
              </Link>

              <Link
                to="/exam"
                style={{ fontSize: "16px" }}
                className=" font-semibold text-gray-900"
              >
                {" "}
                <li>Examinations |</li>{" "}
              </Link>

              <Link
                to="/research"
                style={{ fontSize: "16px" }}
                className=" font-semibold text-gray-900"
              >
                {" "}
                <li>Research |</li>{" "}
              </Link>

              <Link
                to="/iqac"
                style={{ fontSize: "16px" }}
                className="font-semibold text-gray-900"
              >
                <Blink color="blue" text="IQAC |" fontSize="20">
                  IQAC
                </Blink>
              </Link>
              <Link
                to="/nirfa"
                style={{ fontSize: "16px" }}
                className="font-semibold text-gray-900"
              >
                <Blink color="blue" text="NIRF" fontSize="20">
                  IQAC
                </Blink>
              </Link>
            </PopoverGroup>
          </div>
          <div className="mt-6">
            <PopoverGroup className="hidden lg:flex lg:gap-x-12">
              <Popover className="relative">
                <PopoverButton className="flex items-center gap-x-1 text-lg font-semibold text-gray-900">
                  About Us
                  <ChevronDownIcon
                    aria-hidden="true"
                    className="size-5 flex-none text-gray-400"
                  />
                </PopoverButton>

                <PopoverPanel
                  transition
                  className="absolute top-full -left-8 z-10 mt-3 w-screen max-w-56 overflow-hidden rounded-3xl bg-white ring-1 shadow-lg ring-gray-900/5 transition data-closed:translate-y-1 data-closed:opacity-0 data-enter:duration-200 data-enter:ease-out data-leave:duration-150 data-leave:ease-in"
                >
                  <div className="p-4">
                    {products.map((item) => (
                      <div
                        key={item.name}
                        className="group relative flex items-center gap-x-6 rounded-lg p-4 text-sm/6 hover:bg-gray-50"
                      >
                        <div className="flex-auto">
                          <Link
                            style={{ fontSize: "16px" }}
                            className=" font-semibold text-gray-900"
                            to={item.path}
                          >
                            {" "}
                            <li>{item.name}</li>{" "}
                          </Link>
                        </div>
                      </div>
                    ))}
                  </div>
                </PopoverPanel>
              </Popover>

              <Popover className="relative">
                <PopoverButton className="flex items-center gap-x-1 text-lg font-semibold text-gray-900">
                  Admisssion
                  <ChevronDownIcon
                    aria-hidden="true"
                    className="size-5 flex-none text-gray-400"
                  />
                </PopoverButton>

                <PopoverPanel
                  transition
                  className="absolute top-full -left-8 z-10 mt-3 w-screen max-w-60 overflow-hidden rounded-3xl bg-white ring-1 shadow-lg ring-gray-900/5 transition data-closed:translate-y-1 data-closed:opacity-0 data-enter:duration-200 data-enter:ease-out data-leave:duration-150 data-leave:ease-in"
                >
                  <div className="p-4">
                    {admission.map((item) => (
                      <div
                        key={item.name}
                        className="group relative flex items-center gap-x-6 rounded-lg p-4 text-sm/6 hover:bg-gray-50"
                      >
                        <div className="flex-auto">
                          <Link
                            style={{ fontSize: "16px" }}
                            className=" font-semibold text-gray-900"
                            to={item.path}
                          >
                            {" "}
                            <li>{item.name}</li>{" "}
                          </Link>
                        </div>
                      </div>
                    ))}
                  </div>
                </PopoverPanel>
              </Popover>

              <Popover className="relative">
                <PopoverButton className="flex items-center gap-x-1 text-lg font-semibold text-gray-900">
                  Acadamic
                  <ChevronDownIcon
                    aria-hidden="true"
                    className="size-5 flex-none text-gray-400"
                  />
                </PopoverButton>

                <PopoverPanel
                  transition
                  className="absolute top-full -left-8 z-10 mt-3 w-screen max-w-56 overflow-hidden rounded-3xl bg-white ring-1 shadow-lg ring-gray-900/5 transition data-closed:translate-y-1 data-closed:opacity-0 data-enter:duration-200 data-enter:ease-out data-leave:duration-150 data-leave:ease-in"
                >
                  <div className="p-4">
                    {acadamic.map((item) => (
                      <div
                        key={item.name}
                        className="group relative flex items-center gap-x-6 rounded-lg p-4 text-sm/6 hover:bg-gray-50"
                      >
                        <div className="flex-auto">
                          <Link
                            style={{ fontSize: "16px" }}
                            className=" font-semibold text-gray-900"
                            to={item.path}
                          >
                            {" "}
                            <li>{item.name}</li>{" "}
                          </Link>
                        </div>
                      </div>
                    ))}
                  </div>
                </PopoverPanel>
              </Popover>

              <Popover className="relative">
                <PopoverButton className="flex items-center gap-x-1 text-lg font-semibold text-gray-900">
                  Services
                  <ChevronDownIcon
                    aria-hidden="true"
                    className="size-5 flex-none text-gray-400"
                  />
                </PopoverButton>

                <PopoverPanel
                  transition
                  className="absolute top-full -left-8 z-10 mt-3 w-screen max-w-56 overflow-hidden rounded-3xl bg-white ring-1 shadow-lg ring-gray-900/5 transition data-closed:translate-y-1 data-closed:opacity-0 data-enter:duration-200 data-enter:ease-out data-leave:duration-150 data-leave:ease-in"
                >
                  <div className="p-4">
                    {services.map((item) => (
                      <div
                        key={services.name}
                        className="group relative flex items-center gap-x-6 rounded-lg p-4 text-sm/6 hover:bg-gray-50"
                      >
                        <div className="flex-auto">
                          <Link
                            style={{ fontSize: "16px" }}
                            className=" font-semibold text-gray-900"
                            to={item.path}
                          >
                            {" "}
                            <li>{item.name}</li>{" "}
                          </Link>
                        </div>
                      </div>
                    ))}
                  </div>
                </PopoverPanel>
              </Popover>

              <Popover className="relative">
                <PopoverButton className="flex items-center gap-x-1 text-lg font-semibold text-gray-900">
                  Feedback
                  <ChevronDownIcon
                    aria-hidden="true"
                    className="size-5 flex-none text-gray-400"
                  />
                </PopoverButton>

                <PopoverPanel
                  transition
                  className="absolute top-full -left-8 z-10 mt-3 w-screen max-w-56 overflow-hidden rounded-3xl bg-white ring-1 shadow-lg ring-gray-900/5 transition data-closed:translate-y-1 data-closed:opacity-0 data-enter:duration-200 data-enter:ease-out data-leave:duration-150 data-leave:ease-in"
                >
                  <div className="p-4">
                    {feedback.map((item) => (
                      <div
                        key={item.name}
                        className="group relative flex items-center gap-x-6 rounded-lg p-4 text-sm/6 hover:bg-gray-50"
                      >
                        <div className="flex-auto">
                          <Link
                            style={{ fontSize: "16px" }}
                            className=" font-semibold text-gray-900"
                            to={item.path}
                          >
                            {" "}
                            <li>{item.name}</li>{" "}
                          </Link>
                        </div>
                      </div>
                    ))}
                  </div>
                </PopoverPanel>
              </Popover>

              <Popover className="relative">
                <PopoverButton className="flex items-center gap-x-1 text-lg font-semibold text-gray-900">
                  Quick Links
                  <ChevronDownIcon
                    aria-hidden="true"
                    className="size-5 flex-none text-gray-400"
                  />
                </PopoverButton>

                <PopoverPanel
                  transition
                  className="absolute top-full -left-8 z-10 mt-3 w-screen max-w-56 overflow-hidden rounded-3xl bg-white ring-1 shadow-lg ring-gray-900/5 transition data-closed:translate-y-1 data-closed:opacity-0 data-enter:duration-200 data-enter:ease-out data-leave:duration-150 data-leave:ease-in"
                >
                  <div className="p-4">
                    {links.map((item) => (
                      <div
                        key={item.name}
                        className="group relative flex items-center gap-x-6 rounded-lg p-4 text-sm/6 hover:bg-gray-50"
                      >
                        <div className="flex-auto">
                          <Link
                            style={{ fontSize: "16px" }}
                            className=" font-semibold text-gray-900"
                            to={item.path}
                          >
                            {" "}
                            <li>{item.name}</li>{" "}
                          </Link>
                        </div>
                      </div>
                    ))}
                  </div>
                </PopoverPanel>
              </Popover>
            </PopoverGroup>
          </div>
        </div>

        {/* <div className="hidden lg:flex lg:flex-1 lg:justify-end">
          <a href="#" className="text-sm/6 font-semibold text-gray-900">
            Log in <span aria-hidden="true">&rarr;</span>
          </a>
        </div> */}
      </nav>
      <Dialog
        open={mobileMenuOpen}
        onClose={setMobileMenuOpen}
        className="lg:hidden"
      >
        <div className="fixed inset-0 z-10" />
        <DialogPanel className="fixed inset-y-0 right-0 z-10 w-full overflow-y-auto bg-white px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
          <div className="flex items-center justify-between">
            <a href="#" className="-m-1.5 p-1.5">
              <img
                alt=""
                src="https://thenewcollege.edu.in/images/New%20logo%20banner.png"
                className="h-8 w-auto"
              />
            </a>
            <button
              type="button"
              onClick={() => setMobileMenuOpen(false)}
              className="-m-2.5 rounded-md p-2.5 text-gray-700"
            >
              <XMarkIcon aria-hidden="true" className="size-6" />
            </button>
          </div>
          <div className="mt-6 flow-root">
            <div className="-my-6 divide-y divide-gray-500/10">
              <div className="space-y-2 py-6">
                <Disclosure as="div" className="-mx-3 mt-10">
                  <DisclosureButton className="group flex w-full items-center justify-between rounded-lg py-2 pr-3.5 pl-3 text-base/7 font-semibold text-gray-900 hover:bg-gray-50">
                    College Links
                    <ChevronDownIcon
                      aria-hidden="true"
                      className="size-5 flex-none group-data-open:rotate-180"
                    />
                  </DisclosureButton>
                  <DisclosurePanel className="mt-2 space-y-2">
                    {[
                      ...products,
                      ...admission,
                      ...acadamic,
                      ...services,
                      ...feedback,
                      ...links,
                    ].map((item) => (
                      <DisclosureButton
                        key={item.name}
                        as="a"
                        href={item.href}
                        className="block rounded-lg py-2 pr-3 pl-6 text-sm/7 font-semibold text-gray-900 hover:bg-gray-50"
                      >
                        <Link
                          style={{ fontSize: "16px" }}
                          className=" font-semibold text-gray-900"
                          to={item.path}
                        >
                          {" "}
                          <li>{item.name}</li>{" "}
                        </Link>
                      </DisclosureButton>
                    ))}
                  </DisclosurePanel>
                </Disclosure>
                <br></br>
                <Link
                  style={{ fontSize: "16px" }}
                  className=" font-semibold text-gray-900"
                  to="/"
                >
                  {" "}
                  <li>Home</li>{" "}
                </Link>
                <br></br>
                <Link
                  to="/activies"
                  style={{ fontSize: "16px" }}
                  className=" font-semibold text-gray-900"
                >
                  {" "}
                  <li>Activies</li>{" "}
                </Link>
                <br></br>
                <Link
                  to="/facilities"
                  style={{ fontSize: "16px" }}
                  className=" font-semibold text-gray-900"
                >
                  {" "}
                  <li>Facilities</li>{" "}
                </Link>
                <br></br>
                <Link
                  to="/alumini"
                  style={{ fontSize: "16px" }}
                  className=" font-semibold text-gray-900"
                >
                  {" "}
                  <li>Alumini</li>{" "}
                </Link>
                <br></br>
                <Link
                  to="/grievances"
                  style={{ fontSize: "16px" }}
                  className=" font-semibold text-gray-900"
                >
                  {" "}
                  <li>Grievances</li>{" "}
                </Link>
                <br></br>
                <Link
                  to="/moe"
                  style={{ fontSize: "16px" }}
                  className=" font-semibold text-gray-900"
                >
                  {" "}
                  <li>MoE</li>{" "}
                </Link>
                <br></br>
                <Link
                  to="/payment"
                  style={{ fontSize: "16px" }}
                  className=" font-semibold text-gray-900"
                >
                  {" "}
                  <li>Online Payment </li>{" "}
                </Link>
                <br></br>
                <Link
                  to="/exam"
                  style={{ fontSize: "16px" }}
                  className=" font-semibold text-gray-900"
                >
                  {" "}
                  <li>Examinations </li>{" "}
                </Link>
                <br></br>
                <Link
                  to="/research"
                  style={{ fontSize: "16px" }}
                  className=" font-semibold text-gray-900"
                >
                  {" "}
                  <li>Research </li>{" "}
                </Link>
                <br></br>
                <Link
                  to="/iqac"
                  style={{ fontSize: "16px" }}
                  className="font-semibold text-gray-900"
                >
                  {" "}
                  <li>IQAC</li>{" "}
                </Link>
              </div>
            </div>
          </div>
        </DialogPanel>
      </Dialog>
    </header>
  );
}
